(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-collection-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rc-collection-accordion')) {
    class RcCollectionAccordion extends HTMLElement {
      connectedCallback() {
        this.singleOpen = this.dataset.singleOpen === 'true';
        this.scrollOnOpen = this.dataset.scrollOnOpen === 'true';
        this.generation = 0;

        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        const items = this.items();
        items.forEach((item) => this.setOpen(item, false, false));

        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        if (this.dataset.openFirstDesktop === 'true' && isDesktop && items[0]) {
          this.setOpen(items[0], true, false);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      items() {
        return Array.from(this.querySelectorAll('.rc-acc__item'));
      }

      setOpen(item, open, animate = true) {
        const trigger = item.querySelector('.rc-acc__trigger');
        const panel = item.querySelector('.rc-acc__panel');
        if (!animate) {
          panel.style.transition = 'none';
          requestAnimationFrame(() => (panel.style.transition = ''));
        }
        item.classList.toggle('is-open', open);
        if (trigger) trigger.setAttribute('aria-expanded', String(open));
        if (panel) panel.inert = !open;
      }

      // Scroll so `el` sits just below the sticky header. Uses an explicit
      // offset instead of scrollIntoView + scroll-margin, which older iOS
      // Safari versions ignore.
      scrollToEl(el, position = 'top') {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        const rect = el.getBoundingClientRect();
        let y = rect.top + window.scrollY - header - 10;
        if (position === 'center') {
          y = rect.top + window.scrollY - (window.innerHeight - rect.height) / 2;
        }
        window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      // Resolves when a panel finishes its height transition (or after a
      // fallback timeout, in case transitionend never fires).
      afterTransition(item) {
        const panel = item.querySelector('.rc-acc__panel');
        return new Promise((resolve) => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            panel.removeEventListener('transitionend', onEnd);
            resolve();
          };
          const onEnd = (e) => {
            if (e.target === panel) finish();
          };
          panel.addEventListener('transitionend', onEnd);
          window.setTimeout(finish, 400);
        });
      }

      // Waits for an in-progress smooth scroll to stop moving.
      afterScrollSettles() {
        return new Promise((resolve) => {
          let lastY = window.scrollY;
          let still = 0;
          let frames = 0;
          const check = () => {
            frames++;
            still = Math.abs(window.scrollY - lastY) < 0.5 ? still + 1 : 0;
            lastY = window.scrollY;
            if (still >= 4 || frames >= 90) resolve();
            else requestAnimationFrame(check);
          };
          requestAnimationFrame(check);
        });
      }

      async openItem(item, scroll) {
        const gen = ++this.generation;
        const others = this.singleOpen
          ? this.items().filter((other) => other !== item && other.classList.contains('is-open'))
          : [];
        const doScroll = scroll && this.scrollOnOpen;
        const trigger = item.querySelector('.rc-acc__trigger');

        if (others.length && doScroll) {
          // Another panel is open: scroll back to the top of the
          // accordion, close it, then open the new one and scroll to it.
          // Keeps the page from jumping when a long panel collapses.
          const firstTrigger = this.items()[0].querySelector('.rc-acc__trigger');
          this.scrollToEl(firstTrigger);
          await this.afterScrollSettles();
          if (gen !== this.generation) return;

          others.forEach((other) => this.setOpen(other, false));
          await this.afterTransition(others[0]);
          if (gen !== this.generation) return;

          this.setOpen(item, true);
          requestAnimationFrame(() => this.scrollToEl(trigger));
          return;
        }

        others.forEach((other) => this.setOpen(other, false));
        this.setOpen(item, true);
        if (doScroll) requestAnimationFrame(() => this.scrollToEl(trigger));
      }

      async closeItem(item) {
        const gen = ++this.generation;
        this.setOpen(item, false);
        if (!this.scrollOnOpen) return;

        await this.afterTransition(item);
        if (gen !== this.generation) return;
        // After a panel closes, bring the accordion back into view so the
        // visitor isn't left looking at whatever was below it.
        this.scrollToEl(this, 'center');
      }

      onClick(event) {
        const trigger = event.target.closest('.rc-acc__trigger');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();

        const item = trigger.closest('.rc-acc__item');
        if (item.classList.contains('is-open')) {
          this.closeItem(item);
        } else {
          this.openItem(item, true);
        }
      }

      // In the theme editor, selecting a panel or tile opens its panel.
      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('.rc-acc__item');
        if (item && !item.classList.contains('is-open')) this.openItem(item, false);
      }
    }

    customElements.define('rc-collection-accordion', RcCollectionAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
